export const ONLY_DIGIT = /^[0-9]*$/;

// Verifies Number is a negative/positive number.
// Number may be a decimal, but if it is, it requires at least one number before and after the decimal place.
// Decimal numbers may also be negative or positive. Only 1 decimal place is allowed.
// Match: 5.01 5 99 -5.01 -5 -99 1.9e10
// Not Match: 5. .3 k.a
export const SIMPLE_NUMBER = /-?[0-9]+(\.[0-9]+)?(e[0-9]+)?$/;
export const SIMPLE_POSITIVE_NUMBER = /^[0-9]+(\.[0-9]+)?(e[0-9]+)?$/;
export const BETWEEN_ZERO_TO_ONE = /^(0?(\.\d+)?|1(\.0+)?)$/;
export const POSITIVE_DECIMAL = /^(\d*)(\.\d+)?$/;



// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/core/helpers/regular-expressions.ts